import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Space, Typography } from 'antd'

import { getShopifyBaseUrl, isFromCAWebsite } from 'src/utils/helper'

const QuickLinksSection = (): ReactElement => {
  const { t } = useTranslation()
  const baseUrlShopify = getShopifyBaseUrl()
  const isFromCaWebsite = isFromCAWebsite()
  return (
    <Space direction="vertical">
      <Typography.Title level={3}>
        {t('common:footer.sections.quick_links')}
      </Typography.Title>
      <a href={`${baseUrlShopify}/pages/help#shopify-section-help-status`}>
        {t('common:footer.quick_links.check_giftcard')}
      </a>
      <a href={`${baseUrlShopify}/pages/help#shopify-section-help-status`}>
        {t('common:footer.quick_links.check_order')}
      </a>
      <a href={`${baseUrlShopify}/policies/refund-policy`}>
        {t('common:footer.quick_links.refund_policy')}
      </a>
      {isFromCaWebsite && (
        <a href={`${baseUrlShopify}/pages/optician`}>
          {t('common:footer.quick_links.opticians')}
        </a>
      )}
      <a href={`${baseUrlShopify}/pages/social-initiatives`}>
        {t('common:footer.quick_links.social_init')}
      </a>
      <a href={`${baseUrlShopify}/pages/promotions`}>
        {t('common:footer.quick_links.promo_terms')}
      </a>
    </Space>
  )
}

export default QuickLinksSection
